import {
  RecaptchaLibContext,
  RecaptchaLibDispatchContext,
  useRecaptchaLibReducer,
} from '../context/context';
import { RecaptchaLibToken } from '../types/types';
import RecaptchaLibLoader from './RecaptchaLibLoader';

export type RecaptchaLibProviderProps = React.PropsWithChildren<{
  scoreBasedSiteKey?: RecaptchaLibToken,
  checkboxFallbackSiteKey?: RecaptchaLibToken,
}>;

function RecaptchaLibProvider({ children, scoreBasedSiteKey = null, checkboxFallbackSiteKey = null }: RecaptchaLibProviderProps) {
  const [recaptchaLib, dispatch] = useRecaptchaLibReducer();

  return (
    <RecaptchaLibContext.Provider value={recaptchaLib}>
      <RecaptchaLibDispatchContext.Provider value={dispatch}>
        <RecaptchaLibLoader scoreBasedSiteKey={scoreBasedSiteKey} checkboxFallbackSiteKey={checkboxFallbackSiteKey} />
        {children}
      </RecaptchaLibDispatchContext.Provider>
    </RecaptchaLibContext.Provider>
  );
}

export default RecaptchaLibProvider;
